import React from 'react'
import moment from 'moment';

export const fieldValidation = (field, name) => {
  let valid = { error: false, msg: "" }
  if (!field) { valid.error = true; valid.msg = name + " is required." }
  return valid;
}

export const fieldValidationLegalAge = (field, name) => {
  let valid = { error: false, msg: "" }
  if ((!field) || (moment().diff(moment(field),'years', true) <= 18)) {
    valid.error = true; valid.msg = "All Owners must be at least 18 years or Older";
  }
  return valid;
}

export const fieldValidationDriversLicense = (field, name) => {
  let valid = { error: false, msg: "", warning: false }
  let date = field;
  let endOfMonth = moment().endOf('month')
  if (date) {
    if (moment(date).isBefore(moment())) {
      valid.error = true; valid.msg = "Driver's License is expired";
    }
    else if (moment(date).isBetween(moment(), endOfMonth)) {
      valid.error = false; valid.msg = "Driver's License is expiring this month"; valid.warning = true;
    }
  }
  return valid;
}

export const fieldValidationDate = (field, name) => {
  let valid = { error: false, msg: "" }
  if (!field || field == "Invalid Date") { valid.error = true; valid.msg = name + " is required." }

  if (!field && field == "Invalid Date" && field != null) {
    let dateString = field.toString();
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
      valid.error = true; valid.msg = name + " is Invalid Date.";

    // Parse the date parts to integers
    var parts = dateString.split("/");
    var day = parseInt(parts[1], 10);
    var month = parseInt(parts[0], 10);
    var year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month == 0 || month > 12)
      valid.error = true; valid.msg = name + " is Invalid Date.";

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
      monthLength[1] = 29;

    // Check the range of the day
    if (day <= 0 && day > monthLength[month - 1])
      valid.error = true; valid.msg = name + " is Invalid Date.";
  }

  return valid;
}
export const fieldValidationAmount = (field, name) => {
  let valid = { error: false, msg: "" }
  if (!field) { valid.error = true; valid.msg = name + " is required." }
  else if (/^[0-9]+\.[0-9]{2}$/.test(field) === false) { valid.error = true; valid.msg = name + " is not an amount." }
  return valid;
}
export const fieldValidationEmail = (field, name) => {
  let valid = { error: false, msg: "" }
  if (!field) { valid.error = true; valid.msg = name + " is required." }
  else if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(field) === false) { valid.error = true; valid.msg = name + " is not an Email." }
  return valid;
}

export const fieldValidationPhone = (field, name) => {
  let valid = { error: false, msg: "" }
  if (!field) { valid.error = true; valid.msg = name + " is required." }
  else if (/^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/.test(field) === false) { valid.error = true; valid.msg = name + " is not a valid phone number." }
  return valid;
}

export const fieldValidationTaxID = (field, name) => {
  let valid = { error: false, msg: "" }
  if (/^\d{2}-\d{7}$/.test(field) === false) { valid.error = true; valid.msg = name + " is not a valid 9 Digit Tax ID." }
  return valid;

}
export const fieldValidationWebsite = (field, name) => {
  let valid = { error: false, msg: "" }
  if (/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/.test(field) === false) { valid.error = true; valid.msg = name + " is not a valid Url." }
  return valid;
}

export const fieldValidationSSN = (field, name) => {
  let valid = { error: false, msg: "" }
  if (/^\d{3}-\d{2}-\d{4}$/.test(field) === false) { valid.error = true; valid.msg = name + " is not a valid 9 Digit SSN." }
  return valid;
}

export const fieldValidationLicenseNum = (field, name) => {
  let valid = { error: false, msg: "" }
  // if (!field){ valid.error = true; valid.msg = name + " is required." }
  // else 
  if (/^[A-Z](?:\d[- ]*){14}$/.test(field) === false) { valid.error = true; valid.msg = name + " is not a valid Driver's License." }
  return valid;
}

export const fieldValidationZipCode = (field, name) => {
  let valid = { error: false, msg: "" }
  if (!field) { valid.error = true; valid.msg = name + " is required." }
  else if (/^[0-9]{5}(?:-[0-9]{4})?$/.test(field) === false) { valid.error = true; valid.msg = name + " is not a valid 5 Digit Zip Code." }
  return valid;
}

export const fieldValidationOwnerMCDOT = (field, name) => {
  let valid = { error: false, msg: "" }
  if (!field) { valid.error = true; valid.msg = name + " is required." }
  else
    if (/^[0-9]*$/.test(field) === false) { valid.error = true; valid.msg = name + " is not valid." }
  return valid;
}

export const fieldValidationMCDOT = (field, name) => {
  let valid = { error: false, msg: "" }
  // if (!field) { valid.error = true; valid.msg = name + " is required." }
  // else 
  if (/^[0-9]*$/.test(field) === false) { valid.error = true; valid.msg = name + " is not valid." }
  return valid;
}




export const fieldValidation0to99 = (field, name) => {
  let valid = { error: false, msg: "" }
  if (!field) { valid.error = true; valid.msg = name + " is required." }
  else if (/^[0-9]|[1-9][0-9]$/.test(field) === false) { valid.error = true; valid.msg = name + " is not a 0-99." }
  return valid;
}

export const fieldValidationFloat = (field, name) => {
  let valid = { error: false, msg: "" }
  if (!field) { valid.error = true; valid.msg = name + " is required." }
  else if (/[+]?([0-9]*[.])?[0-9]+/.test(field) === false) { valid.error = true; valid.msg = name + " is not a percent." }
  return valid;
}


export const fieldValidationOwnerMCDOTOptional = (field, name) => {
  let valid = { error: false, msg: "" }
  if (!field) { valid.error = true; valid.msg = name + " is optional." }
  else
    if (/^[0-9]*$/.test(field) === false) { valid.error = true; valid.msg = name + " is not valid." }
  return valid;
}

export const fieldValidationPlain = (field, name) => {
  let valid = { error: false, msg: "" }
  if (!field) { valid.error = true; valid.msg = name }
  return valid;
}